import { ResultEnum } from "../services/result-enum";

class VarianceNumberTypeService {
  varianceNumberType(amount: number) {
      if (amount === 0) {
        return ResultEnum.Equal;
      }
      else if (amount > 0) {
        return ResultEnum.Positive;
      }
      else {
        return ResultEnum.Negative;
      }
    }
}
export default new VarianceNumberTypeService();
